import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const AppendContainer = styled.div`
  display: flex;
  gap: 16px;
  color: ${Colors.GS600};
`

export const AppendLoaderContainer = styled.div`
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
`
